<template>
  <DashboardPage>
    <AuctionForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import AuctionForm from './components/AuctionForm.vue';

const route = useRoute()

</script>